import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksTestimonials } from '@/graphql/__generated__/global/types';
import { EmblaCarousel } from '../../elements/Carousel/Carousel';
import { TestimonialCard } from './TestimonialCard';

export const BlockTestimonials = ({ titleDescription, testimonials }: IComponentBlocksTestimonials) => {
    if (!testimonials?.data) {
        return;
    }

    return (
        <>
            {titleDescription && (
                <Container>
                    <TitleAndDescription {...titleDescription} />
                </Container>
            )}
            <Container paddingX={false} maxWidth="xl">
                <EmblaCarousel
                    emblaOptions={{
                        align: 'start',
                        slidesToScroll: 'auto',
                        containScroll: 'trimSnaps',
                        loop: testimonials?.data.length > 3 ? true : false,
                    }}
                >
                    {({ emblaRef, scrollSnaps, scrollTo, scrollProgress, scrollNext, scrollPrev }) => {
                        return (
                            <>
                                <EmblaCarousel.Slides ref={emblaRef}>
                                    {testimonials?.data?.map((card, index) => {
                                        return <TestimonialCard key={index} {...card?.attributes} image={card?.attributes?.image} />;
                                    })}
                                </EmblaCarousel.Slides>
                                <Container maxWidth="xl">
                                    <EmblaCarousel.ProgressBar
                                        max={scrollSnaps.length}
                                        scrollTo={scrollTo}
                                        centered={true}
                                        scrollProgress={scrollProgress}
                                        scrollNext={scrollNext}
                                        scrollPrev={scrollPrev}
                                    />
                                </Container>
                            </>
                        );
                    }}
                </EmblaCarousel>
            </Container>
        </>
    );
};

export default BlockTestimonials;
